export default {
  style: 0
};